import { render, staticRenderFns } from "./LinksResources.vue?vue&type=template&id=0cdc21cc"
import script from "./LinksResources.vue?vue&type=script&lang=js"
export * from "./LinksResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports